"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = __importDefault(require("../../../../components/_classes/component/editForm/utils"));
const Evaluator_1 = require("../../../../utils/Evaluator");
exports.default = [
    {
        key: 'labelPosition',
        ignore: true
    },
    {
        key: 'placeholder',
        ignore: true
    },
    {
        key: 'description',
        ignore: true
    },
    {
        key: 'hideLabel',
        ignore: false
    },
    {
        key: 'autofocus',
        ignore: true
    },
    {
        key: 'tooltip',
        ignore: true
    },
    {
        key: 'tabindex',
        ignore: true
    },
    {
        key: 'disabled',
        ignore: true
    },
    {
        type: 'select',
        key: 'align',
        label: 'Align',
        input: true,
        dataSrc: 'values',
        weight: 100,
        tooltip: 'Align.',
        data: {
            values: [
                { label: 'Left', value: 'justify-content-start' },
                { label: 'Center', value: 'justify-content-center' },
                { label: 'Right', value: 'justify-content-end' },
                { label: 'Full', value: 'justify-content-between' }
            ],
        },
    },
    {
        type: 'select',
        input: true,
        weight: 21,
        tooltip: 'Select currency you use.',
        key: 'showCurrency',
        defaultValue: 'LAK',
        label: 'Currency',
        dataSrc: 'values',
        data: {
            values: [
                { label: 'US Dollar (USD)', value: 'USD' },
                { label: 'Euro (EUR)', value: 'EUR' },
                { label: 'Riel (KHR)', value: 'KHR' },
                { label: 'Yen (JPY)', value: 'JPY' },
                { label: 'Lao Kip (LAK)', value: 'LAK' },
                { label: 'Kyat (MMK)', value: 'MMK' },
                { label: 'Singapore Dollar (SGD)', value: 'SGD' },
                { label: 'Dong (VND)', value: 'VND' },
            ],
        },
        conditional: {
            json: { '===': [{ var: 'data.showType' }, 'amount'] },
        },
    },
    {
        type: 'select',
        input: true,
        weight: 20,
        tooltip: 'Select type you\'d like to use.',
        key: 'showType',
        defaultValue: 'text',
        label: 'Type',
        dataSrc: 'values',
        data: {
            values: [
                { label: 'Text', value: 'text' },
                { label: 'List', value: 'list' },
                { label: 'Number', value: 'number' },
                { label: 'Date time', value: 'datetime' },
                { label: 'Amount', value: 'amount' },
                { label: 'Link', value: 'link' },
                { label: 'File', value: 'file' },
                { label: 'Image', value: 'img' },
                { label: 'E-sign', value: 'esign' },
            ],
        },
    },
    {
        label: 'Show File',
        key: 'showfile',
        input: true,
        weight: 21,
        type: 'checkbox',
        tooltip: 'When activated, it will allow to show file in webview.',
        conditional: {
            json: {
                or: [
                    { '===': [{ var: 'data.showType' }, 'file'] },
                    { '===': [{ var: 'data.showType' }, 'img'] },
                ]
            },
        },
    },
    {
        type: 'textarea',
        key: 'custom',
        label: 'Button Custom Logic',
        tooltip: 'The custom logic to evaluate when the button is clicked.',
        rows: 5,
        editor: 'ace',
        input: true,
        weight: 103,
        placeholder: "data['mykey'] = data['anotherKey'];",
        conditional: {
            json: { '===': [{ var: 'data.action' }, 'custom'] },
        },
    },
    // {
    //   weight: 200,
    //   type: 'textarea',
    //   input: true,
    //   rows: 5,
    //   editor: 'ace',
    //   key: 'textContent',
    //   label: 'Text Content',
    //   placeholder: 'Text Content',
    //   tooltip: 'Text Content.',
    // }
    {
        type: 'textarea',
        label: 'Template',
        key: 'templatesTextinfo',
        rows: 5,
        editor: 'ace',
        as: 'handlebars',
        clearOnHide: false,
        weight: 201,
        input: true,
        placeholder: '/*** Lodash Template Code only work when Type is List ***/',
        tooltip: 'This is the <a href=\'https://lodash.com/docs/4.17.5#template\'>Lodash Template</a> used to render each row ',
        customConditional({ data }) {
            return (!Evaluator_1.Evaluator.noeval || Evaluator_1.Evaluator.protectedEval) && !data.displayAsTable;
        },
        conditional: {
            json: { '===': [{ var: 'data.showType' }, 'list'] },
        },
    },
    utils_1.default.javaScriptValue('Text Content', 'textContent', 'textContent', 200, '<p><h4>Example:</h4><pre>value = data.a + data.b + data.c;</pre></p>', '<p><h4>Example:</h4><pre>{"+": [{"var": "data.a"}, {"var": "data.b"}, {"var": "data.c"}]}</pre>', '<tr><th>token</th><td>The decoded JWT token for the authenticated user.</td></tr>'),
];
